import React from 'react'

export const Column = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={`flex flex-col ${className}`} {...props}></div>
)
